import { Component, EventEmitter, Input, Output, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SelectItem } from 'primeng/primeng';
import { Observable } from 'rxjs/Observable';
import { ProvinceService } from '../../../../services/province/province.service';
import { CountryService } from '../../../../services/country/country.service';
import { CustomerInfoService } from '../../../../services/customer/customerinfo.service';
import { CustomerBasicInfo, CustomerCompanyData, mgCustomerCompany } from '../../../../models/customer.model';
import { ClassificationService } from '../../../../services/classification/classification.service';
import { KoncentroValidators } from '../../../../modules/UIKit/validators/koncentro-validators';
import { AutoComplete, InputText } from 'primeng/primeng';
import { CalendarTranslate } from '../../../../models/calendarTranslate.model';
import { CalendarTranslateService } from '../../../../modules/UIKit/services/calendarTranslate.service';
import { CustomerCardService } from '../../../../services/customer/customer-card.service';
import { LoyaltyCardService } from '../../../../services/loyalty/loyalty-card.service';
import * as moment from 'moment';
import { StoreCommonService } from '../../../../services/store/store-common.service';
import { ToponymService } from '../../../../services/toponym/toponym.service';
import { AuthService } from '../../../../services/user/auth.service';
import { LoyaltyGiftReservationService } from '../../../../services/loyalty/loyalty-gift-reservation.service';
import { MessageService } from 'primeng/api';
import { CustomersService } from '../../../../services/customer/customers.service';
import { CustomerCardListModel } from './../../../../models/customer-cards.model';
import { LoyaltyChannelService } from './../../../../services/loyalty/loyalty-channel.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-customer-company-basic-new',
  templateUrl: './customer-company-basic-new.component.html',
  styleUrls: ['./customer-company-basic-new.component.css'],
  providers: []
})
export class CustomerCompanyBasicNewComponent implements OnInit {

  @Input() customerId: string;
  @Input() editMode: boolean;
  @Input() cardInfo: CustomerCardListModel[];

  @Output() basicInfoLoaded = new EventEmitter();
  @Output() companyInfoLoaded = new EventEmitter();
  @Output() cardsInfoLoaded = new EventEmitter();
  @Output() dirtyFormData = new EventEmitter();
  @Output() allMandatoryFieldsOkLoaded = new EventEmitter();
  @ViewChild('autocompleteCard') private autocompleteCard: AutoComplete;
  @ViewChild('inputCard') private inputCard: InputText;

  availableCards: CustomerCardListModel[];
  fields: any;
  formData: FormGroup;
  calendarTranslate: CalendarTranslate;
  code_cards: SelectItem[] = [];
  channels: SelectItem[] = [];
  domiciliationStores: SelectItem[] = [];
  invalidSubmit: boolean;
  cardIdSelected: number;
  cardNoSelected: string;
  storeIdSelected: number;
  maxDate: Date = new Date();
  country: any = null;
  provinces: SelectItem[] = [];
  preferredStores: SelectItem[] = [];
  settore: SelectItem[] = [];
  toponyms: SelectItem[] = [];
  //userId: string;
  basicInfo: CustomerBasicInfo;
  companyInfo: CustomerCompanyData[];
  classificationInfo: any[];
  //cardInfo: Array<CustomerCardListModel>;
  showEmailOrMobileError: boolean = false;

  validators = {
    fiscalCode: KoncentroValidators.fiscalCode,
    emailOrEmpty: KoncentroValidators.emailOrEmpty,
    phone: KoncentroValidators.phone_mg,
    onlyNumbers: KoncentroValidators.number
  }

  constructor(
    private srvLoyaltyCard: LoyaltyCardService,
    private srvCustomerCard: CustomerCardService,
    private srvCustomer: CustomerInfoService,
    private srvCalendarTranslate: CalendarTranslateService,
    private fb: FormBuilder,
    private srvStoreCommon: StoreCommonService,
    private srvCountry: CountryService,
    private srvProvince: ProvinceService,
    private classificationService: ClassificationService,
    private srvToponyms: ToponymService,
    private authService: AuthService,
    private srvLoyaltyGiftReservation: LoyaltyGiftReservationService,
    private router: Router,
    private srvNotify: MessageService,
    private srvCustomers: CustomersService,
    private srvCustomerInfo: CustomerInfoService,
    private srvChannel: LoyaltyChannelService,
    private customerInfoSrv: CustomerInfoService,
    private translate: TranslateService
  ) { }

  ngOnInit() {


  /*
    NOTE DI LOGICA:

    Inserimento cliente:
    Se le opzioni della combo puntoVendita hanno un solo record solo allora lo si deve selezionare direttamente.
    Questo record viene fuori dalla lista di negozi a cui l'utente è abilitato.

    Modifica cliente:
    Al differenza dell'inserimento, quì non si considera più il negozio a cui è abilitato l'utente,
    ma la combo del puntoVendita viene popolata con il negozio trovato nella carta.
  */

    this.code_cards = [];
    this.channels = [];
    this.domiciliationStores = [{value: null, label: ''}];
    this.preferredStores = [{value: null, label: ''}];
    this.toponyms = [{value: null, label: ''}];
    this.provinces = [];

    var CALENDAR = this.srvCalendarTranslate.pCalendar;
    var FIELDS = this.srvCustomer.getMgCustomerCompanyFields();
    this.maxDate.setFullYear(this.maxDate.getFullYear() - 18);
    let domiciliationStores: Observable<any>;
    let provinces: Observable<any>;
    domiciliationStores = this.srvStoreCommon.getList(0,9999);
    let toponyms: Observable<any>;
    toponyms = this.srvToponyms.getAll();
    //let divisionStores: Observable<any>;
    let PREFSTORES = this.srvStoreCommon.getAllStores(999);
    //this.userId = this.authService.user.id.toString();
    //divisionStores = this.srvStoreCommon.getUserStoresAndSalesNetworks(this.userId);
    let search = [
      {key: 'name',value: 'italia' },
      {key: 'flg_state',value: '0'}
    ];

    var COUNTRIES = this.srvCountry.list(null,null,search);

    var GETBASICINFO = Observable.of(null);
    var GETCOMPANYINFO = Observable.of(null);
    var GETCLASSIFICATIONINFO = Observable.of(null);
    if(this.editMode){
      GETBASICINFO = this.srvCustomer.getBasicInfo(this.customerId);
      GETCOMPANYINFO = this.srvCustomers.getCompanyData(this.customerId);
      GETCLASSIFICATIONINFO = this.srvCustomerInfo.getClassification(this.customerId);
    }

    Observable.zip(
      domiciliationStores,
      PREFSTORES,
      //divisionStores,
      COUNTRIES,
      toponyms,
      CALENDAR,
      FIELDS,
      GETBASICINFO,
      GETCOMPANYINFO,
      GETCLASSIFICATIONINFO
    )
    .subscribe(([
      resDomiciliationStores,
      resPreferredStores,
      //resDivisionStores,
      resCountries,
      resToponyms,
      resCalendar,
      resFields,
      resBasicInfo,
      resCompanyInfo,
      resClassificationInfo,
    //  resCardsInfo
    ]) => {
      this.calendarTranslate = resCalendar;
      this.fields = resFields;

      this.loadClassificationValues();

      for (const store of resPreferredStores) {
        this.preferredStores.push({
          value: store.id,
          label: store.code + ' - ' + store.description
        });
      }

      for (const toponym of resToponyms) {
        this.toponyms.push({
          value: toponym.id,
          label: toponym.name
        });
      }
          //*** SOLO IN FASE DI EDIT ***
          if(this.editMode){
            if(resBasicInfo && resBasicInfo.customerCode) {

                if(resCountries){
                  this.country = resCountries.data[0];
                  if(this.country !== null) {
                    provinces = this.srvProvince.getAll(this.country.id);
                  } else {
                    provinces = this.srvProvince.getAll(-1);
                  }

                  provinces.subscribe(resProvinces=>{
                    if(resProvinces){
                      this.provinces.push({value: null, label: ''});
                      for (const province of resProvinces) {
                        this.provinces.push({
                          value: province.id,
                          label: province.name
                        });
                      }

                      let cust:mgCustomerCompany = new mgCustomerCompany();
                      if(resBasicInfo && resBasicInfo.customerCode){
                        this.basicInfo = resBasicInfo;
                        cust.customerId = +this.customerId;
                        cust.puntoVenditaPref = this.basicInfo.preferred_store_id ? this.basicInfo.preferred_store_id.toString() : "";
                        this.companyInfo = resCompanyInfo ? resCompanyInfo : null;
                        cust.flgType = this.companyInfo ? this.companyInfo[0].flg_type : '';
                        cust.ragioneSociale = this.companyInfo ? this.companyInfo[0].company_name : '';
                        cust.partitaIva_codiceFiscale = this.companyInfo ? this.companyInfo[0].vat_code || this.companyInfo[0].fiscal_code : '';
                        this.classificationInfo = resClassificationInfo ? resClassificationInfo : null;
                        cust.settore = (this.classificationInfo && this.classificationInfo.length > 0) ? this.classificationInfo[0].classification_detail_id.toString() : '';
                        cust.emailAziendale = this.companyInfo ? this.companyInfo[0].email_primary : '';
                        cust.mobileAziendale = this.companyInfo ? this.companyInfo[0].phone_mobile : '';
                        cust.cognome = this.basicInfo.surname;
                        cust.nome = this.basicInfo.name;
                        cust.birthDate = this.basicInfo.birthday;
                        cust.fiscalCode = this.basicInfo.fiscal_code;
                        cust.toponym = this.basicInfo.toponym_id ? this.basicInfo.toponym_id.toString() : "";
                        cust.address = this.basicInfo.address;
                        cust.addressNumber = this.basicInfo.address_number;
                        cust.comune = this.basicInfo.city;
                        cust.zipCode = this.basicInfo.zip_code;
                        cust.province = this.basicInfo.province_id;
                        cust.flgAuth1 = this.basicInfo.flag_privacy;
                        cust.flgAuth2 = this.basicInfo.flag_marketing_activities;
                        cust.flgAuth3 = this.basicInfo.flag_profiling;
                        cust.flgAuthPush = this.basicInfo.flag_push_notifications;
                      }

                      if(this.cardInfo){
                        //this.cardInfo = resCardsInfo;
                        var self = this;
                        if(this.cardInfo && this.cardInfo.length){
                            this.srvChannel.get(this.cardInfo[0].channel_id).subscribe(res=>{
                              if(res){
                                cust.cardNo = this.cardInfo[0].cardNo;

                                self.channels = [];
                                self.channels.push({
                                  value: res.id,
                                  label: res.channel_code + ' - ' + res.description
                                });

                                let search = [
                                  {key: 'cardId',value: this.cardInfo[0].cardId.toString() }
                                ];
                                var self2 = this;
                                this.srvLoyaltyCard.list(null, null, search).subscribe(resCard => {
                                  if(resCard && resCard.data.length && resCard.data.length == 1) {

                                    self2.domiciliationStores = [];
                                    self2.domiciliationStores.push({
                                      value: resCard.data[0].store_id,
                                      label: resCard.data[0].store
                                    });

                                    self2.basicInfoLoaded.emit(self2.editMode ? self2.basicInfo : null);
                                    self2.companyInfoLoaded.emit(self2.editMode ? self2.companyInfo[0] : null);
                                    self2.cardsInfoLoaded.emit(self2.editMode ? self2.cardInfo : null);
                                    self2.createForm(self2.editMode ? cust : null);

                                    var self3 = this;
                                    setTimeout(function(){
                                      self3.formData.controls.cardNo.setValue(self3.cardInfo[0].cardNo);
                                      self3.formData.controls.channel.setValue(self3.cardInfo[0].channel_id.toString())
                                      self3.formData.controls.puntoVendita.setValue(self3.cardInfo[0].store_id.toString());
                                      if(self3.basicInfo){
                                        self3.formData.controls.puntoVenditaPref.setValue(self3.basicInfo.preferred_store_id);
                                      }
                                      self3.checkAllMandatoryFields();

                                    },100);
                                  }
                                });
                              }
                            });

                        }
                      }
                    }
                  });
                }
            }
          }
          else{

              for (const store of resDomiciliationStores) {
                this.domiciliationStores.push({
                  value: store.id,
                  label: store.code + ' - ' + store.description
                });
              }

              /* SOLO IN FASE DI INSERT */
              if(resCountries){
                this.country = resCountries.data[0];
                if(this.country !== null) {
                  provinces = this.srvProvince.getAll(this.country.id);
                } else {
                  provinces = this.srvProvince.getAll(-1);
                }

                provinces.subscribe(resProvinces=>{
                  if(resProvinces){
                    this.provinces.push({value: null, label: ''});
                    for (const province of resProvinces) {
                      this.provinces.push({
                        value: province.id,
                        label: province.name
                      });
                    }

                    this.basicInfoLoaded.emit(null);
                    this.companyInfoLoaded.emit(null);
                    this.cardsInfoLoaded.emit(null);
                    this.createForm(null);

                      var self2 = this;
                      setTimeout(function(){

                        if(resDomiciliationStores && resDomiciliationStores.length == 1){
                          self2.formData.controls.puntoVendita.setValue(resDomiciliationStores[0].id);
                        }
                      },100);
                }
                });
              }
          }
    });
  }

  createForm(data: mgCustomerCompany){
    const isNew = data == null;
    console.log('createForm data ', data);

    this.formData = this.fb.group({
      customerId:                     this.editMode ? data.customerId : null,
      puntoVendita:                   this.editMode ? data.puntoVendita : '',
      puntoVenditaPref:               this.editMode ? data.puntoVenditaPref : '',
      channel:                        this.editMode ? data.channel : '',
      cardNo:                         this.editMode ? data.cardNo : '',
      flgType:                        this.editMode ? data.flgType : 'A',
      ragioneSociale:                 this.editMode ? data.ragioneSociale : '',
      partitaIva_codiceFiscale:       this.editMode ? data.partitaIva_codiceFiscale : '',
      settore:                        this.editMode ? data.settore : '',
      emailAziendale:                 this.editMode ? data.emailAziendale : '',
      mobileAziendale:                this.editMode ? data.mobileAziendale : '',
      cognome:                        this.editMode ? data.cognome : '',
      nome:                           this.editMode ? data.nome : '',
      birthDate:                      (!isNew && data.birthDate) ? [moment(data.birthDate).toDate(), KoncentroValidators.dateNotAfter(this.maxDate)] : null,
      fiscalCode:                     this.editMode ? data.fiscalCode : '',
      toponym:                        this.editMode ? data.toponym : '',
      address:                        this.editMode ? data.address : '',
      addressNumber:                  this.editMode ? data.addressNumber : '',
      comune:                         this.editMode ? data.comune : '',
      zipCode:                        this.editMode ? data.zipCode : '',
      province:                       this.editMode ? data.province : null,
      flgAuth1:                       this.editMode ? data.flgAuth1 === '1' : true,
      flgAuth2:                       this.editMode ? data.flgAuth2 === '1'  : false,
      flgAuth3:                       this.editMode ? data.flgAuth3 === '1' : false,
      flgAuthPush:                    this.editMode ? data.flgAuthPush === '1' : false,
      checkFiscalDataExistence:       true
    });

    var self = this;
    setTimeout(function(){
      if(!self.editMode){
        self.autocompleteCard.focusInput();
      }
    },100);
  }
  checkAllMandatoryFields(){        
    if( this.formData.valid){
      this.allMandatoryFieldsOkLoaded.emit(true);
    }
    else{
      this.allMandatoryFieldsOkLoaded.emit(false);
    }
  }
  puntoVenditaChange(newValue):void {
    //in fase di edit non può essere cambiato
    if(!this.editMode){
      if(newValue === null && (!newValue || newValue =="")) {
        this.storeIdSelected = 0;
      }else{
        this.storeIdSelected = newValue;
      }
      this.formData.controls.puntoVenditaPref.reset();
      this.formData.controls.puntoVenditaPref.setValue(newValue);
    }

  }

  filterCardSingle(event){
    if(event && event.query && event.query.length>0){
      this.srvCustomerCard.getAvailableCards(event.query).subscribe(res=>{
        if(res){
          this.availableCards = res;
          this.code_cards = [{value: null, label: ''}];
          for (const codeCard of res) {
            if(codeCard.flagBlackList != "1"){
              this.code_cards.push({
                value: codeCard.cardId,
                label: codeCard.cardNo
              });
            }
          }
        }
      });
    }
  }

  codiceCartaChange(newValue): void {
    //in fase di edit non può essere cambiato
    if(!this.editMode){
      if(newValue === null && (!newValue.value || newValue.value=="")) {
        this.channels = [];
        this.formData.controls.channel.reset();
        this.formData.controls.puntoVendita.reset();
      } else {
        let search = [
          {key: 'cardId',value: newValue.value }
        ];
        this.srvLoyaltyCard.list(null, null, search).subscribe(res => {

          if(res && res.data.length && res.data.length == 1) {

            this.cardIdSelected = newValue.value;
            this.cardNoSelected = res.data[0].card_no;

            if(res && res.data && res.data.length && res.data.length == 1){

                this.channels.push({
                  value: res.data[0].channel_id,
                  label: res.data[0].channelCode + ' - ' + res.data[0].channelDescription
                });

                let index = this.availableCards.findIndex(x=>x.cardId == this.cardIdSelected);

                if(index>-1){
                  this.formData.controls.customerId.setValue(this.availableCards[index].customerId);
                }

                this.formData.controls.channel.setValue(this.channels[0].value);
                //Questo è il punto vendita trovato nella carta, ma è commentato perchè non ci devo far nulla in fase di inserimento
                //this.formData.controls.puntoVendita.setValue(res.data[0].store_id);
            }
          }
        });
      }
    }
  }

  onClickDropdownCarta(event){
    this.code_cards = [];
    this.srvCustomerCard.getAvailableCards(event.query).subscribe(res=>{
      this.availableCards = res;
      this.code_cards = [{value: null, label: ''}];
      for (const codeCard of res) {
        if(codeCard.flagBlackList != "1"){
          this.code_cards.push({
            value: codeCard.cardId,
            label: codeCard.cardNo + ' (' + codeCard.cardType + ')'
          });
        }
      }
    });
  }

  loadClassificationValues() {
    this.classificationService.getTypes('customer').switchMap(classificationTypes => {
      return this.classificationService.getList(classificationTypes[0].id);
    }).subscribe(classifications => {

      this.classificationService.getDetails(classifications[0].id).subscribe(res => {
        this.settore = [{ label: '', value: null }];
        for (const classification of res) {
          this.settore.push({ label: classification.description, value: classification.id });
        }
      });
    });
  }
  checkEmailOrMobile(): boolean{
    let res = true;
    if(!this.formData.controls.emailAziendale.value && !this.formData.controls.mobileAziendale.value){
      this.showEmailOrMobileError = true;
      res = false;
    }
    return res;
  }

  saveMg() {
    console.log('saveMg()');
    //ulteriore controllo sul flag auth1
    if(this.formData.get("flgAuth1").value == false){
      this.formData.get("flgAuth1").setValue(null);
    }

    if (!this.formData.valid) {
      this.invalidSubmit = true;
      return;
    }

    if(this.checkEmailOrMobile() == false){
      this.invalidSubmit = true;
      return;
    }

    this.invalidSubmit = false;

    if(this.editMode){
      this.srvCustomer.updateMgCustomerCompany(this.formData.value).subscribe(res => {
        if(res){
          var self = this;
          this.translate.get(['common.updateSuccess']).subscribe(res => {
            self.srvNotify.add({severity: 'info', summary: 'Confirmed', detail: res['common.updateSuccess']});
            setTimeout(function(){
              self.router.navigate(['/customers-infosheet-new'], { queryParams: { saved: 1, customerCode: self.basicInfo.customerCode } });
            },200);
          });
        }
      });
    }else{
      this.srvCustomer.createMgCustomerCompany(this.formData.value).subscribe(res => {
        if(res && res.id){
          if(this.storeIdSelected > 0){
            this.customerInfoSrv.updateCardStore(this.cardIdSelected, this.cardNoSelected, this.storeIdSelected).subscribe();
          }

          let customerCode: string = res.customerCode;
          var self = this;
          this.translate.get(['common.saveSuccess']).subscribe(res => {
            self.srvNotify.add({severity: 'info', summary: 'Confirmed', detail: res['common.saveSuccess']});
            setTimeout(function(){
              self.router.navigate(['/customers-infosheet-new'], { queryParams: { saved: 1, customerCode: customerCode } });
            },200);
          });
        }
      });

      /*** CANCELLARE QUESTO COMMENTO DI SEGUITO, una volta verificato che va tutto bene */
      /*
      this.srvCustomer.createMgCustomerCompany(this.formData.value).subscribe(res => {
        if(res && res.id){
          if(this.storeIdSelected > 0){
            this.customerInfoSrv.updateCardStore(this.cardIdSelected, this.cardNoSelected, this.storeIdSelected).subscribe();
          }
          let customerHostId: number = res.id;
          let customerCode: string = res.customerCode;
          this.customerInfoSrv.getVCustomerByHost(customerHostId.toString()).subscribe(res => {
            if(res && res.id){
              let vCustomerId: number = res.id;
              this.customerInfoSrv.addCard(vCustomerId, customerHostId, this.cardIdSelected, this.cardNoSelected).subscribe(res => {
                if(res){
                  var self = this;
                  this.translate.get(['common.saveSuccess']).subscribe(res => {
                    self.srvNotify.add({severity: 'info', summary: 'Confirmed', detail: res['common.saveSuccess']});
                    setTimeout(function(){
                      self.router.navigate(['/customers-infosheet-new'], { queryParams: { saved: 1, customerCode: customerCode } });
                    },200);
                  });
                }
              });
            }
          });
        }
      });
      */
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-company/customer-company-basic-new/customer-company-basic-new.component.ts